// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_io-0";
export var actionModalContentContainer = "_io-1";
export var createTagButton = "_io-2";
export var footerContainer = "_io-7";
export var fullWidthDivider = "_io-3";
export var hasCreateTagButton = "_io-4";
export var noCreateTagButton = "_io-5";
export var tagsContainer = "_io-6";
export var tagsModalContentContainer = "_io-8";